export default {
  waitDocs: 'wait-docs',
  validateDocs: 'validate-docs',
  completed: 'completed',
};
